<div class="modal-header">
  <h4 class="modal-title">{{ title | translate }}</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="cancelClicked.emit()"></button>
</div>
<div class="modal-body">
  <ng-content></ng-content>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="cancelClicked.emit()">{{ cancelLabel | translate }}</button>
  <button type="button" class="btn btn-primary" [disabled]="saveDisabled" (click)="saveClicked.emit()">{{ saveLabel | translate }}</button>
</div>

